// Mock data for development and testing
// TODO: Replace with real API calls when backend is ready

// Authorized users (for authorization check)
export const authorizedUsers = [
  { email: 'admin@test.com', name: 'Admin User', role: 'admin' },
  { email: 'manager@test.com', name: 'Report Manager', role: 'manager' },
  { email: 'viewer@test.com', name: 'Viewer User', role: 'viewer' },
];

// Mock reports
export const mockReports = [
  {
    id: 1,
    name: 'Monthly Sales Report',
    description: 'Comprehensive monthly sales analysis',
    category: 'Sales',
    filePath: '/reports/sales/monthly_sales.pdf',
    deliveryMethod: 'SIGNED_URL',
    lastUpdated: '2026-01-28',
    createdBy: 'admin@test.com',
    groups: [1, 2],
    emails: [1, 6],
    sftpSites: [],
  },
  {
    id: 2,
    name: 'Customer Analytics',
    description: 'Customer behavior and trends',
    category: 'Analytics',
    filePath: '/reports/analytics/customer_analytics.pdf',
    deliveryMethod: 'SFTP',
    lastUpdated: '2026-01-25',
    createdBy: 'manager@test.com',
    groups: [],
    emails: [],
    sftpSites: [1, 2],
  },
  {
    id: 3,
    name: 'Financial Summary Q4',
    description: 'Q4 financial performance summary',
    category: 'Finance',
    filePath: '/reports/finance/q4_summary.pdf',
    deliveryMethod: 'SIGNED_URL',
    lastUpdated: '2026-01-20',
    createdBy: 'admin@test.com',
    groups: [3],
    emails: [1, 18],
    sftpSites: [],
  },
  {
    id: 4,
    name: 'HR Headcount Report',
    description: 'Monthly headcount and attrition data',
    category: 'Operations',
    filePath: '/reports/hr/headcount_monthly.pdf',
    deliveryMethod: 'SFTP',
    lastUpdated: '2026-02-01',
    createdBy: 'manager@test.com',
    groups: [],
    emails: [],
    sftpSites: [3],
  },
];

// Mock groups (with child group support)
export const mockGroups = [
  {
    id: 1,
    name: 'Executive Team',
    description: 'C-level executives and senior management',
    emailCount: 5,
    childGroupCount: 0,
    createdDate: '2025-12-01',
    isActive: true,
    emails: [1, 2, 3, 4, 5],
    childGroups: [],
  },
  {
    id: 2,
    name: 'Sales Department',
    description: 'Sales team members and managers',
    emailCount: 12,
    childGroupCount: 1,
    createdDate: '2025-12-05',
    isActive: true,
    emails: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    childGroups: [5], // contains Sales UK
  },
  {
    id: 3,
    name: 'Finance Team',
    description: 'Finance and accounting department',
    emailCount: 8,
    childGroupCount: 0,
    createdDate: '2025-12-10',
    isActive: true,
    emails: [18, 19, 20, 21, 22, 23, 24, 25],
    childGroups: [],
  },
  {
    id: 4,
    name: 'All Departments',
    description: 'All department distribution groups combined',
    emailCount: 2,
    childGroupCount: 3,
    createdDate: '2025-12-15',
    isActive: true,
    emails: [1, 2],
    childGroups: [1, 2, 3], // contains Executive, Sales, Finance
  },
  {
    id: 5,
    name: 'Sales UK',
    description: 'UK-based sales representatives',
    emailCount: 4,
    childGroupCount: 0,
    createdDate: '2026-01-10',
    isActive: true,
    emails: [7, 8, 10, 11],
    childGroups: [],
  },
  {
    id: 6,
    name: 'Quarterly Reviewers',
    description: 'Stakeholders who receive quarterly review reports',
    emailCount: 3,
    childGroupCount: 2,
    createdDate: '2026-01-15',
    isActive: true,
    emails: [1, 6, 18],
    childGroups: [1, 3], // contains Executive, Finance
  },
  {
    id: 7,
    name: 'Operations Team',
    description: 'Operations and logistics staff',
    emailCount: 0,
    childGroupCount: 0,
    createdDate: '2026-01-20',
    isActive: true,
    emails: [],
    childGroups: [],
  },
];

// Mock emails
export const mockEmails = [
  { id: 1, email: 'ceo@company.com', name: 'CEO', verificationStatus: 'verified', dateAdded: '2025-12-01', lastAttempt: '2025-12-01' },
  { id: 2, email: 'cfo@company.com', name: 'CFO', verificationStatus: 'verified', dateAdded: '2025-12-01', lastAttempt: '2025-12-01' },
  { id: 3, email: 'cto@company.com', name: 'CTO', verificationStatus: 'verified', dateAdded: '2025-12-01', lastAttempt: '2025-12-01' },
  { id: 4, email: 'coo@company.com', name: 'COO', verificationStatus: 'verified', dateAdded: '2025-12-01', lastAttempt: '2025-12-01' },
  { id: 5, email: 'cmo@company.com', name: 'CMO', verificationStatus: 'pending', dateAdded: '2026-01-28', lastAttempt: '2026-01-28' },
  { id: 6, email: 'sales.manager@company.com', name: 'Sales Manager', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 7, email: 'sales1@company.com', name: 'Sales Rep 1', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 8, email: 'sales2@company.com', name: 'Sales Rep 2', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 9, email: 'sales3@company.com', name: 'Sales Rep 3', verificationStatus: 'failed', dateAdded: '2025-12-05', lastAttempt: '2026-01-20' },
  { id: 10, email: 'sales4@company.com', name: 'Sales Rep 4', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 11, email: 'sales5@company.com', name: 'Sales Rep 5', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 12, email: 'sales6@company.com', name: 'Sales Rep 6', verificationStatus: 'pending', dateAdded: '2026-01-25', lastAttempt: '2026-01-25' },
  { id: 13, email: 'sales7@company.com', name: 'Sales Rep 7', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 14, email: 'sales8@company.com', name: 'Sales Rep 8', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 15, email: 'sales9@company.com', name: 'Sales Rep 9', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 16, email: 'sales10@company.com', name: 'Sales Rep 10', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 17, email: 'sales11@company.com', name: 'Sales Rep 11', verificationStatus: 'verified', dateAdded: '2025-12-05', lastAttempt: '2025-12-05' },
  { id: 18, email: 'finance.manager@company.com', name: 'Finance Manager', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
  { id: 19, email: 'accountant1@company.com', name: 'Accountant 1', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
  { id: 20, email: 'accountant2@company.com', name: 'Accountant 2', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
  { id: 21, email: 'accountant3@company.com', name: 'Accountant 3', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
  { id: 22, email: 'accountant4@company.com', name: 'Accountant 4', verificationStatus: 'pending', dateAdded: '2026-01-22', lastAttempt: '2026-01-22' },
  { id: 23, email: 'accountant5@company.com', name: 'Accountant 5', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
  { id: 24, email: 'accountant6@company.com', name: 'Accountant 6', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
  { id: 25, email: 'accountant7@company.com', name: 'Accountant 7', verificationStatus: 'verified', dateAdded: '2025-12-10', lastAttempt: '2025-12-10' },
];

// Mock SFTP sites
export const mockSftpSites = [
  { id: 1, name: 'Finance SFTP', description: 'SFTP site for finance reports', awsSecretName: 'tui-dev-boxi-sftp-finance', isActive: true, reportCount: 0 },
  { id: 2, name: 'HR SFTP', description: 'SFTP site for HR reports', awsSecretName: 'tui-dev-boxi-sftp-hr', isActive: true, reportCount: 1 },
  { id: 3, name: 'Operations SFTP', description: 'SFTP site for operations reports', awsSecretName: 'tui-dev-boxi-sftp-operations', isActive: true, reportCount: 1 },
  { id: 4, name: 'Analytics SFTP', description: 'SFTP site for analytics reports', awsSecretName: 'tui-dev-boxi-sftp-analytics', isActive: false, reportCount: 0 },
];

// Mock users (Cognito users with roles)
export const mockUsers = [
  { id: 1, email: 'admin@test.com', name: 'Admin User', role: 'admin', status: 'active', lastLogin: '2026-02-02' },
  { id: 2, email: 'manager@test.com', name: 'Report Manager', role: 'manager', status: 'active', lastLogin: '2026-02-01' },
  { id: 3, email: 'viewer@test.com', name: 'Viewer User', role: 'viewer', status: 'active', lastLogin: '2026-01-30' },
  { id: 4, email: 'disabled@test.com', name: 'Disabled User', role: 'viewer', status: 'disabled', lastLogin: '2025-12-15' },
];

// Helper functions
export const getReportById = (id) => mockReports.find((r) => r.id === id);
export const getGroupById = (id) => mockGroups.find((g) => g.id === id);
export const getEmailById = (id) => mockEmails.find((e) => e.id === id);
export const getUserById = (id) => mockUsers.find((u) => u.id === id);
export const getSftpSiteById = (id) => mockSftpSites.find((s) => s.id === id);

export const getReportsByGroup = (groupId) => mockReports.filter((r) => r.groups.includes(groupId));
export const getEmailsByGroup = (groupId) => {
  const group = getGroupById(groupId);
  return group ? group.emails.map((emailId) => getEmailById(emailId)).filter(Boolean) : [];
};
export const getChildGroupsByGroup = (groupId) => {
  const group = getGroupById(groupId);
  return group ? group.childGroups.map((gId) => getGroupById(gId)).filter(Boolean) : [];
};

export const isUserAuthorized = (email) => authorizedUsers.some((u) => u.email === email);

// Mock Pickup Folders
export const mockPickupFolders = [
  { id: 'pf-001', name: 'Finance Reports', description: 'Monthly finance reports for external auditors', s3Prefix: 'boxi_pickup/pf-001/', retentionDays: 30, isActive: true, reportCount: 2, userCount: 1, createdAt: '2026-01-15T10:00:00Z' },
  { id: 'pf-002', name: 'HR Documents', description: 'HR reports for payroll provider', s3Prefix: 'boxi_pickup/pf-002/', retentionDays: 60, isActive: true, reportCount: 1, userCount: 2, createdAt: '2026-02-01T14:30:00Z' },
  { id: 'pf-003', name: 'Operations Data', description: 'Operational reports for logistics partner', s3Prefix: 'boxi_pickup/pf-003/', retentionDays: 14, isActive: true, reportCount: 0, userCount: 0, createdAt: '2026-03-10T09:15:00Z' },
  { id: 'pf-004', name: 'Legacy Archive', description: 'Old reports - being phased out', s3Prefix: 'boxi_pickup/pf-004/', retentionDays: 7, isActive: false, reportCount: 0, userCount: 1, createdAt: '2025-11-20T16:00:00Z' },
];

// Mock Pickup Users
export const mockPickupUsers = [
  { id: 'pu-001', username: 'auditor_finance', folderIds: ['pf-001'], folderNames: ['Finance Reports'], isActive: true, createdAt: '2026-01-20T11:00:00Z' },
  { id: 'pu-002', username: 'payroll_provider', folderIds: ['pf-002'], folderNames: ['HR Documents'], isActive: true, createdAt: '2026-02-05T09:30:00Z' },
  { id: 'pu-003', username: 'logistics_partner', folderIds: ['pf-002', 'pf-004'], folderNames: ['HR Documents', 'Legacy Archive'], isActive: true, createdAt: '2026-02-10T15:45:00Z' },
  { id: 'pu-004', username: 'old_vendor', folderIds: ['pf-004'], folderNames: ['Legacy Archive'], isActive: false, createdAt: '2025-12-01T08:00:00Z' },
];

export const getPickupFolderById = (id) => mockPickupFolders.find((f) => f.id === id);
export const getPickupUserById = (id) => mockPickupUsers.find((u) => u.id === id);
